import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuctionService, LoaderService } from '../../../services';
import { AuctionCurrentState } from '../../../models';
import routeTable from '../../../utility/routeTable';

@Injectable()
export class AuctionStatusResolver implements Resolve<AuctionCurrentState> {
  auctionCodeParam = routeTable.public.publicLink;
  constructor(
    private auctionService: AuctionService,
    private loader: LoaderService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<AuctionCurrentState> {
    this.loader.showLoader(true);
    return new Promise((resolve) => {
      this.auctionService
        .getAuctionCurrentStatus(
          route.paramMap.get(this.auctionCodeParam.split(':')[1])
        )
        .toPromise()
        .then((res) => {
          this.loader.showLoader(false);
          resolve(res);
        })
        .catch(() => {
          this.loader.showLoader(false);
          resolve(null);
        });
    });
  }
}
